import styled from "styled-components/native";
import {
  BorderRadiusProps,
  BackgroundColorProps,
  PaddingProps,
  paddingProps,
  marginProps,
  backgroundColorProps,
  borderRadiusProps,
} from "@sloth-system/props";

export { Box };

export type BoxProps = BorderRadiusProps & BackgroundColorProps & PaddingProps;

let Box = styled.View<BoxProps>`
  ${paddingProps}
  ${backgroundColorProps}
  ${borderRadiusProps}
  ${marginProps}
`;
